import React from 'react';
import { Link } from 'react-router-dom';
import About1 from '../../images/Office-Interiors2.jpg';
import { Helmet } from 'react-helmet';

const Officeinteriors = (props) => {

      const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    
    return (

         <>
      <Helmet>
        <title>Office Interiors</title>
        <meta name="description" content="Smart Office Designs for Modern Workplaces" />
        <meta name="keywords" content="about, company, mission, team" />
      </Helmet>
     <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="row align-items-center">

                <div className="col-lg-6 col-12">
                        <div className="about-left">
                            <img src={About1} alt="" />
                            
                        </div>
                    </div>
                    
                    <div className="col-lg-6 col-12">
                        <div className="about-right">
                            <div className="text">
                                <span>About</span>
                                <h1>Office Interiors</h1>
                                <h6>Smart Office Designs for Modern Workplaces</h6>
                                <p>
                                Create a workspace that enhances productivity, comfort, and visual appeal. Our office interior 
                                solutions are tailored for startups, small businesses, and large corporate environments.
                                </p>
                                <h4>What we offer :</h4>
                                <ul>
                                    <li>Workstation & desk layouts</li>
                                    <li>Conference room design</li>
                                    <li>Modular partition systems</li>
                                    <li>Ergonomic furniture planning</li>
                                    <li>Data, electrical, and lighting solutions</li>
                                    <p>Upgrade your office aesthetics and functionality — partner with YATRI INTERIORS.</p>
                                </ul>
                              <a href='tel:9663222146' className='theme-btn'>Call Us: +91 96632 22146</a>
                            </div>
                        </div>
                    </div>
                
                
                </div>
            </div>
        </section>
    </>
        
    )
}

export default Officeinteriors ;